var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spCapitalList"},[(_vm.user.providerstatus == 10)?_c('sPCapitalList',{attrs:{"hostroletype":_vm.hostroletype}}):_c('serviceProviderTip')],1)}
var staticRenderFns = []

export { render, staticRenderFns }